import { find, findIndex } from 'lodash'
import Vue from 'vue'

export default {
  setInitialised (state, value) {
    state.initialised = value
  },

  storeBranding (state, branding) {
    state.branding = branding
  },

  init (state) {
    var office = localStorage.getItem('office')
    if (office) {
      state.selectedOffice = JSON.parse(office)
    }
  },

  setDigitalHubLink (state, link) {
    state.digitalHubLink = link
  },

  storeSystem (state, system) {
    state.system = system
  },

  updateProfile (state, profile) {
    state.profile = profile
  },

  updateProfileV2 (state, profile) {
    state.profile_v2 = profile
  },

  updatePageLoading (state, value) {
    state.pageLoading = value
  },

  setCurrentProperty (state, property) {
    state.currentProperty = property
  },

  getActiveProperties (state, office) {
    state.activeProperties = office
  },

  getPropertyEnums (state, enums) {
    state.propertyEnums = enums
  },

  getProperty24Provinces (state, provinces) {
    state.property24.provinces = provinces
  },

  getProperty24Cities (state, data) {
    state.property24.cities[data.provinceId] = data.cities
  },

  getProperty24Suburbs (state, data) {
    state.property24.suburbs[data.cityId] = data.suburbs
  },

  getMarketingPackNotifications (state, data) {
    state.marketingPackNotifications = data
  },

  setActiveAnnualReview (state, data) {
    state.annualReview = data
  },

  setToastNotification (state, notification) {
    state.toast = notification
  },

  activeProperties (state, properties) {
    state.properties = properties
  },

  setUserOffices (state, offices) {
    state.userOfficeList = offices
  },

  setSelectedOffice (state, office) {
    state.selectedOffice = office
    localStorage.setItem('office', JSON.stringify(office))
  },

  updateMenus (state, menus) {
    state.menus = menus.map(m => {
      m.expanded = false
      return m
    })
  },

  deleteMenu ({ menus }, menu) {
    if (menu.parent_id !== null) {
      let parent = find(menus, m => m.id === menu.parent_id)
      menus = parent.children
    }

    let index = menus.indexOf(menu)

    if (index >= 0) {
      menus.splice(index, 1)
    }
  },

  updatePages (state, pages) {
    state.pages = pages
  },

  setPage ({ pages }, page) {
    let old = find(pages, (p) => p.slug === page.slug)
    let index = pages.indexOf(old)
    if (index >= 0) {
      pages.splice(index, 1, page)
    } else {
      pages.push(page)
    }
  },

  setArticles (state, articles) {
    state.articles = articles
  },

  setArticle ({ articles }, article) {
    let old = find(articles, a => a.slug === article.slug)
    if (old) {
      old = article
    } else {
      articles.push(article)
    }
  },

  setReferralTerms (state, terms) {
    state.referralTerms = terms
  },

  updateAdmin (state, admin) {
    state.admin = admin
  },

  removeItem ({ admin }, item) {
    let index = admin.items.indexOf(item)
    if (index >= 0) {
      admin.items.splice(index, 1)
    }
  },

  nullActivePropertiesMutation (state) {
    state.activeProperties = null
  },

  updateUserOffice ({ userOfficeList }, office) {
    let i = findIndex(userOfficeList, o => o.id === office.id)

    if (i === -1) {
      userOfficeList.push(office)
    } else {
      userOfficeList.splice(i, 1, office)
    }
  },

  setNotifications (state, notifications) {
    state.notifications = notifications
  },

  setVideoBrandingLogo (state, VideoBrandingLogo) {
    state.selectedVideoBradingOption.logo = VideoBrandingLogo
  },
  setVideoBrandingTransition (state, transition) {
    state.selectedVideoBradingOption.transition = transition
  },
  setVideoBrandingOption (state, VideoBrandingOption) {
    state.selectedVideoBradingOption.branding = VideoBrandingOption
  },

  setVideoBraningCallToAction (state, VideoBraningCallToAction) {
    state.selectedVideoBradingOption.callToAction = VideoBraningCallToAction
  },
  setAudioBradingOption (state, AudioBradingOption) {
    state.selectedVideoBradingOption.backingMusic = AudioBradingOption
  },
  setPresenterBrandingOption (state, presenterBrandingOption) {
    state.selectedVideoBradingOption.showPresenter = presenterBrandingOption
  },
  setMergeVideoetteOption (state, mergeVideoetteOption) {
    state.selectedVideoBradingOption.mergeVideoette = mergeVideoetteOption
  },

  updateVideoetteSettings (state, items) {
    state.videoettes.logoItems = items['logo']
    state.videoettes.transitionItems = items['transition']
    state.videoettes.brandingItems = items['branding']
    state.videoettes.backingMusicItems = items['backing music']
  },

  setOfficePreset (state, preset, type) {
    if (type === 'videoette') {
      // @todo promote this data into the store, it currently resides in the component itself
    }

    state.selectedVideoBradingOption = {
      ...state.selectedVideoBradingOption,
      id: preset.id,
      office_id: preset.office_id,
      user_id: preset.user_id,
      logo: preset.logo,
      branding: preset.branding ? preset.branding : { id: null },
      transition: preset.transition,
      backingMusic: preset.backing_music,
      showPresenter: preset.presenter_enabled
    }
  },

  storeVideoettes (state, videoettes, page = 1) {
    if (page > 1) {
      state.videoettes.propertyVideos.concat(videoettes)
    } else {
      state.videoettes.propertyVideos = videoettes
    }
  },

  setSavingBrandingPresets (state, req) {
    state.savingBrandingPresets = req
  },

  setActiveChildMenu (state, slug) {
    state.menus.forEach(m => {
      m.children.forEach(c => {
        if (c.slug === slug) {
          m.expanded = true
        }
      })
    })
  },

  setAvailabilityTimes (state, blocks) {
    state.availabilityTimes = blocks
  },

  updateAvailabilityTime (state, time) {
    let index = findIndex(state.availabilityTimes[time.weekday], el => {
      return el.id === time.id
    })

    Vue.set(state.availabilityTimes[time.weekday], index, time)
  },

  replaceNewAvailabilityTime (state, time) {
    let index = findIndex(state.availabilityTimes[time.weekday], el => {
      return el.id === null
    })

    Vue.set(state.availabilityTimes[time.weekday], index, time)
  },

  deleteAvailabilityTime (state, time) {
    let index = findIndex(state.availabilityTimes[time.weekday], el => {
      return el.id === time.id
    })

    state.availabilityTimes[time.weekday].splice(index, 1)
  },

  addAvailabilityTime (state, time) {
    state.availabilityTimes[time.weekday].push(time)
  },

  setPagesLoading (state, bool) {
    state.pagesLoading = bool
  },

  updatePotentialReferralCount (state, newCount) {
    state.potentialReferralCount = newCount
  }
}
